import { render, staticRenderFns } from "./VAlert.vue?vue&type=template&id=e244a420"
import script from "./VAlert.vue?vue&type=script&lang=ts"
export * from "./VAlert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports